import { Component, OnInit } from '@angular/core';
import { SICallTypes, topBottomLocationRow } from '../../types/service-insight-types';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { FiltersService } from 'src/app/core/services/filters.service';
import { ServiceInsightsService } from '../../services/service-insights-service.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { Router } from '@angular/router';
import { ServiceInsightsDetailsStore } from '../../stores/service-insights-details.store';


@Component({
    selector: 'location-insights-table',
    templateUrl: './location-insights-table.component.html',
    styleUrls: ['./location-insights-table.component.scss', '../../../../../styles.scss'],
    standalone: false
})
// TODO US631513: Component leverages Angular Material v16 which has been deprecated.
// Consider updating to the latest version OR moving away from the library to gain more control over the UI and reduce dependency on external libraries.
export class LocationInsightsTableComponent implements OnInit {

  filters: ContractModel | undefined;
  serviceInsightsSubscription: Subscription | undefined;

  displayLoader : boolean = false;

  displayColumns : string[] = ['location', 'extraServiceCalls','avgExtraServiceRequests', 'vsAvg', 'issues', 'recurringIssues'];
  displayColumns2 : string[] = ['location', 'extraServiceCalls','avgExtraServiceRequests',  'vsAvg', 'issues', 'recurringIssues', 'addAll'];
  dropDownOptions : {option: string, value: {optionName: string, value: number}}[] = [
    {option:'5', value:{optionName: '5', value: 5}},
    {option:'10', value:{optionName: '10', value: 10}},
    {option:'5%', value:{optionName: '5%', value: 0}},
    {option:'10%', value:{optionName: '10%', value: 0}}
  ];

  displayOption = (option: {
    option: string;
    value: { optionName: string; value: number };
  }) => option.option;

  preSelectedDropDownValue = this.dropDownOptions[0].value;
  currentDropDownValue = this.dropDownOptions[0].value;

  initialData: any[] = [];
  data : topBottomLocationRow[] = [];
  dataSource : MatTableDataSource<topBottomLocationRow> = new MatTableDataSource(this.data)

  tabSelected:string = 'bottom';
  checked: boolean | undefined = false;

  checkedStateMap: Map<{optionName: string, value: number}, boolean> = new Map();

  /** Custom sort state for the refreshed UI (no Angular Material dependency). */
  sortColumn: string = ''; // TODO: Migrate to enums
  sortDirection: 'asc' | 'desc' | '' = '';

  constructor(
    private _filterService: FiltersService,
    private _serviceInsightsService: ServiceInsightsService,
    private _mixpanelService: MixpanelService,
    private _router: Router,
    private _siDetailsStore: ServiceInsightsDetailsStore,
  ) {}

  /** Returns the full option object whose `.value` matches `currentDropDownValue`, used by single-select-input. */
  get selectedDropDownOption() {
    return (
      this.dropDownOptions.find((o) => o.value === this.currentDropDownValue) ??
      null
    );
  }

  /** Rows shown in the refreshed UI table, respecting the active custom sort. */
  get sortedData(): topBottomLocationRow[] {
    const rows = this.dataSource.data;
    if (!this.sortColumn || !this.sortDirection) {
      return rows;
    }
    const col = this.sortColumn as keyof topBottomLocationRow;
    const dir = this.sortDirection === 'asc' ? 1 : -1;
    return [...rows].sort((a, b) => {
      const aVal = a[col] ?? '';
      const bVal = b[col] ?? '';
      if (aVal < bVal) return -dir;
      if (aVal > bVal) return dir;
      return 0;
    });
  }

  async ngOnInit() {
    this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);
    this.serviceInsightsSubscription = this._serviceInsightsService.getLocationsTopBottomData().subscribe(d => this.data = d);

    if(this.filters !== undefined){
      this.displayLoader=true;
      if (this.data.length == 0) {
        this._serviceInsightsService.setLocationsTopBottomData(await this.getTopBottomLocationData());
      }

      //use Math.ceil for percentages, so in case the calculated percentage value is <1, round up to 1
      this.dropDownOptions = [
        {option:'5', value:{optionName: '5', value: 5}},
        {option:'10', value:{optionName: '10', value: 10}},
        {option:'5%', value:{optionName: '5%', value: Math.ceil(this.data.length * 0.05)}},
        {option:'10%', value:{optionName: '10%', value: Math.ceil(this.data.length * 0.10)}}
      ]

      this.preSelectedDropDownValue = this.dropDownOptions[0].value;
      this.currentDropDownValue = this.dropDownOptions[0].value;

      this.dropDownOptions.forEach((item) => {
        this.checkedStateMap.set(item.value, false);
      });
      //initial to bottom units, sorted by ESRs descending
      let halfData = this._getSplitDataSet(this.tabSelected);
      this.dataSource = new MatTableDataSource(halfData);
      this.dataSource.data = this.dataSource.data.slice(0,this.preSelectedDropDownValue.value);

      this.displayLoader=false;
    }else{
      this.data = [];
      this.dataSource = new MatTableDataSource(this.data);
    }

  }

  async getTopBottomLocationData(){
    return this._serviceInsightsService.getTopBottomLocationInsights();
  }

  //will reassign this.dataSource
  updateTableRowsDisplay(){

    //get half dataset then sort by ESR descending regardless of tab selected
    let halfData = this._getSplitDataSet(this.tabSelected);
    this.dataSource = new MatTableDataSource(halfData);


    //then slice data to only show 5, 10, 5%, 10%
    this.dataSource.data = halfData.slice(0,this.currentDropDownValue.value);
  }

  //will return half of the data set depending on whether the top or bottom tab is selected
  private _getSplitDataSet(tab:string) : topBottomLocationRow[]{
    let middle : number = Math.round(this.data.length/2);

    //bottom locations have the lowest number of ESRs
    if(tab==='top'){
      return this.data.slice(0, middle);
    }else{ //tab==='bottom'
      return this.data.slice(middle, this.data.length).reverse();
    }

  }

  async changeTab(tab:string){
    this._serviceInsightsService.changeTopBottomLocsInPresentation(this.tabSelected, this.currentDropDownValue.optionName, false);
    this.tabSelected = tab;
    this.updateTableRowsDisplay();
    this.checked = false;
    this._mixpanelService.track('Service Insights- Top/Bottom Location Tab Clicked', {
      'Dropdown Options': this.currentDropDownValue.value
  })}

  //parameter type and function may need to change after DTO is determined
  getVsAverageColor(percentage: number) : string{
    let backgroundColor :string = 'lightgray'

    let percentageNum = percentage;

    if(percentageNum >= 75){
      backgroundColor = '#DF3935';
    }
    else if(percentageNum >=25 ){
      backgroundColor = '#F17A22'
    }
    else{ // less than 25
      backgroundColor = '#39B54A'
    }

    return backgroundColor;
  }

  _onCheckedChange(b: boolean) {
    // for the future
    // this.checkedStateMap.set(this.currentDropDownValue, b);
    // this._serviceInsightsService.changeTopBottomLocsInPresentation(this.tabSelected, this.currentDropDownValue.optionName, b);

    this._setBulkAddedVals(b);
    this.setCheckedState(this.currentDropDownValue);
  }

  private _setBulkAddedVals(b: boolean) {
    this.checkedStateMap.set(this.dropDownOptions[0].value, b);
    this.checkedStateMap.set(this.dropDownOptions[1].value, b);
    this._serviceInsightsService.changeTopBottomLocsInPresentation(this.tabSelected, this.currentDropDownValue.optionName, b);
  }

  private setCheckedState(stateVal: any) {
    this.checked = this.checkedStateMap?.get(stateVal);
  }

  onAccountClick(element: topBottomLocationRow) {
    this._mixpanelService.track('Location Insights - Account Drill-through Clicked', {
      'Account Name': element.accountName,
      'Tab Selected': this.tabSelected
    });
    this._siDetailsStore.setSelectedServiceInsightsMetric(SICallTypes.ExtraServiceVisit);
    this._router.navigate(['/service-insights/extra-service-visits'], {
      state: {
        accountNumber: element.accountNumber,
        accountName: element.accountName
      }
    });
  }

  /**
   * Handle page size change event from the dropdown.
   * Used with custom @see SingleSelectComponent for page size selection and replaces legacy mat-select workflow.
   * @param value page size value
   */
  onPageSizeChange(option: any) {
    this.currentDropDownValue = option.value;

    this._serviceInsightsService.changeTopBottomLocsInPresentation(
      this.tabSelected,
      this.currentDropDownValue.optionName,
      false,
    );

    this.setCheckedState(option.value);
    this.updateTableRowsDisplay();

    this._mixpanelService.track(
      'Location Insights table show dropdown changed',
      {
        'Dropdown Value': this.currentDropDownValue.optionName,
        'Tab Selected': this.tabSelected,
      },
    );

    this.checked = false;
  }

  /**
    * Toggles sort direction for the selected column in the refreshed UI table.
    * Re-clicking the active column switches between `asc` and `desc`.
    * Selecting a different column resets that column to `asc`.
   */
  onSortChange(column: string): void {
    if (this.sortColumn !== column) {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    } else {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    }

    this._mixpanelService.track('Service Insights - Location Insights - Column Sort Clicked', {
      'Sort Active': this.sortColumn,
      'Sort Direction': this.sortDirection
    });
  }
}
